import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.scss";
import App from "./App";
import { GlobalStateProvider } from "./context/GlobalStateContext";
import { SessionContextProvider } from "./context/SessionContext";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <GlobalStateProvider>
      <SessionContextProvider>
        <App />
      </SessionContextProvider>
    </GlobalStateProvider>
  </BrowserRouter>,
);
